var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { doc, onSnapshot, getFirestore } from "firebase/firestore";
import fb from "./firebase";
import EventHeader from "./components/Pages/Register/EventHeader";
import { withStyles } from "@material-ui/core/styles";
import { FormControlLabel, FormGroup, Switch } from "@material-ui/core";
var walker1 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-1.png";
var walker2 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-2.png";
var walker3 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-3.png";
var walker4 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-4.png";
var walker5 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-5.png";
var walker6 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-6.png";
var walker7 = "https://brushfirecontent.blob.core.windows.net/0000/Media/walk-7.png";
var brandBlue = "#004bed";
var brandBlueDk = "#0033a1";
var BlueSwitch = withStyles({
    switchBase: {
        "&$checked": {
            color: brandBlue,
        },
        "&$checked + $track": {
            backgroundColor: brandBlueDk,
        },
    },
    checked: {},
    track: {},
})(Switch);
function getNumberWithOrdinal(n) {
    var s = ["th", "st", "nd", "rd"], v = n % 100;
    return (_jsxs("span", { children: [n, _jsx("sup", { children: s[(v - 20) % 10] || s[v] || s[0] })] }));
}
var QueueView = function (_a) {
    var _b, _c;
    var me = _a.me, settings = _a.settings, eventNumber = _a.eventNumber, urlKey = _a.urlKey, clientKey = _a.clientKey, playAudio = _a.playAudio, setPlayAudio = _a.setPlayAudio;
    var _d = __read(useState(), 2), event = _d[0], setEvent = _d[1];
    var handleChange = function (event) {
        setPlayAudio(event.target.checked);
    };
    var firestore = getFirestore(fb);
    var peopleRepetitions = 4;
    var images = [];
    var seconds = -48;
    var factor = 1;
    var urls = [
        walker1,
        walker2,
        walker3,
        walker4,
        walker5,
        walker2,
        walker6,
        walker7,
        //
        walker1,
        walker4,
        walker3,
        walker5,
        walker7,
        walker6,
        //
        walker4,
        walker2,
        walker5,
        walker6,
        walker1,
        walker3,
        walker4,
    ];
    urls.forEach(function (url, index) {
        images.push(_jsx("img", { src: url, alt: "Person standing in line", style: { animationDelay: (seconds / urls.length) * index + "s" } }));
    });
    useEffect(function () {
        if (eventNumber) {
            return onSnapshot(doc(firestore, "events", eventNumber), function (doc) {
                var data = doc.data();
                setEvent(data);
            });
        }
    }, [eventNumber]);
    return (_jsxs(_Fragment, { children: [event ? (_jsx("div", __assign({ className: "ta-left" }, { children: _jsx(EventHeader, { event: event, currentTab: 2, isLoading: !event, isWidget: true, userCanManage: false, path: "" }) }))) : (_jsx(_Fragment, { children: !!eventNumber && (_jsx("div", __assign({ className: "well lg ta-center d-block" }, { children: _jsx("div", __assign({ className: "well-content" }, { children: "..." })) }))) })), _jsx("div", __assign({ className: "well lg well-lg ta-center d-block" }, { children: _jsxs("div", __assign({ className: "well-content" }, { children: [_jsx("h2", __assign({ className: "bold" }, { children: "You're now in the queue!" })), ((_b = settings.clients[clientKey]) === null || _b === void 0 ? void 0 : _b.queueMessage) && _jsx("p", { children: settings.clients[clientKey].queueMessage }), _jsx("p", { children: settings.heading }), !settings.paused && (_jsx(_Fragment, { children: (me === null || me === void 0 ? void 0 : me.p) ? (_jsxs(_Fragment, { children: [_jsxs("h3", __assign({ className: "bold" }, { children: ["You are ", (me === null || me === void 0 ? void 0 : me.allow) ? "next" : getNumberWithOrdinal((_c = me === null || me === void 0 ? void 0 : me.p) !== null && _c !== void 0 ? _c : 1), " in line.", " ", (me === null || me === void 0 ? void 0 : me.e) !== undefined && !(me === null || me === void 0 ? void 0 : me.allow) && me.e < 600
                                                ? "Your estimated wait time is ".concat(me.e < 3600
                                                    ? "less than ".concat(Math.ceil(me.e / 60), " minute").concat(Math.ceil(me.e / 60) === 1 ? "" : "s")
                                                    : "less than ".concat(Math.ceil(me.e / 3600), " hour").concat(Math.ceil(me.e / 3600) === 1 ? "" : "s"), ".")
                                                : ""] })), (me === null || me === void 0 ? void 0 : me.o) && (me === null || me === void 0 ? void 0 : me.p) && (_jsx("div", __assign({ className: "queue-status" }, { children: _jsx("div", { className: "queue-status-indicator", style: { width: (me === null || me === void 0 ? void 0 : me.allow) ? "100%" : "".concat(100 - (me.p / me.o) * 100, "%") } }) })))] })) : (_jsxs(_Fragment, { children: [_jsx("h3", __assign({ className: "bold" }, { children: "Calculating your place in line" })), _jsx("div", __assign({ className: "queue-status" }, { children: _jsx("div", { className: "queue-status-indicator", style: { width: "0%" } }) }))] })) })), _jsx("p", { children: settings.body }), _jsx(FormGroup, { children: _jsx(FormControlLabel, { style: { justifyContent: "center" }, control: _jsx(BlueSwitch, { checked: playAudio, onChange: handleChange, inputProps: { "aria-label": "controlled" }, color: "primary" }), label: "Play a sound when it's my turn" }) }), _jsx("div", __assign({ className: "walker-frame walkers-".concat(peopleRepetitions) }, { children: images }))] })) }))] }));
};
export default QueueView;
